<app-card>
  <app-card-title size="large">
    {{ 'maintenance.title' | translate }}
  </app-card-title>
  <div class="maintenance-actions push-top">

    <!-- Reset all -->
    <app-maintenance-confirmable-action (confirmedClick)="onResetAllClick()">
      {{ 'maintenance.actions.reset_all_and_reload' | translate }}
    </app-maintenance-confirmable-action>

    <!-- Non-production only: store & restore Digital Signage credentials -->
    @if (isNonProd && credentialsAction) {
      <ng-container #storage="appCredentialsStorage"
                    appMaintenanceCredentialsStorage>
        @if (credentialsAction === 'store') {
          <app-maintenance-confirmable-action (confirmedClick)="storage.onStoreClick();">
            {{ 'maintenance.actions.store_credentials' | translate }}
          </app-maintenance-confirmable-action>
        } @else {
          <app-maintenance-confirmable-action (confirmedClick)="storage.onRestoreClick();">
            {{ 'maintenance.actions.restore_credentials' | translate }}
          </app-maintenance-confirmable-action>
        }
      </ng-container>
    }

    <!-- Go back -->
    <button (click)="onGoBackClick()">
      {{ 'maintenance.actions.go_back' | translate }}
    </button>
  </div>
</app-card>
